module.exports = __webpack_public_path__ + "img/tick.7bbabee2.svg";